import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import Activities from './shared-components/Activities';
import Header from './shared-components/Header';
import {
  paypalPageAtom,
  paypalRowsAtom,
  businessAtom,
  paypalPayoutsAtom,
  loadingPaypalPayoutsAtom,
  refreshPaypalPayoutsAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function Paypal() {
  const business = useRecoilValue(businessAtom);
  const [page, setPage] = useRecoilState(paypalPageAtom);
  const [rows, setRows] = useRecoilState(paypalRowsAtom);
  const setPaypalPayouts = useSetRecoilState(paypalPayoutsAtom);
  const setLoadingPaypalPayouts = useSetRecoilState(loadingPaypalPayoutsAtom);
  const [refreshPaypalPayouts, setRefreshPaypalPayouts] = useRecoilState(refreshPaypalPayoutsAtom);
  function getData() {
    setLoadingPaypalPayouts(true);
    setRefreshPaypalPayouts(false);
    let tempPage = page - 1;
    if (tempPage < 0) {
      tempPage = 0;
    }
    let url = `payments/payoutswithcountbytype/1/${tempPage}/${rows}`;
    if (business) {
      url += `/${business.id}`;
    }
    api
      .get(url)
      .then((response) => {
        setLoadingPaypalPayouts(false);
        if (response.data.success) {
          setPaypalPayouts(response.data.data);
        } else {
          setPaypalPayouts(null);
        }
      })
      .catch(() => {
        setLoadingPaypalPayouts(false);
      });
  }
  useEffect(async () => {
    await setPage(1);
    await setRows(10);
    getData();
  }, []);
  useEffect(() => {
    getData();
  }, [business, page, refreshPaypalPayouts, rows]);
  useEffect(() => {
    if (refreshPaypalPayouts) {
      getData();
    }
  }, [refreshPaypalPayouts]);
  return (
    <>
      <Header />
      {/* <Balances />
      <Divider /> */}
      <Activities />
    </>
  );
}

export default Paypal;
